import { useContext } from "react";
import { UXPContext } from "./Context";
/**
 * @export
 * A custom React hook that retrieves the UXPContext, throwing an error if used outside a UXPContextProvider.
 *
 * @returns The UXPContext object.
 * @throws Error if the hook is used outside a UXPContextProvider.
 *
 * @example
 * ```
 * import { UXPContext } from './Context';
 * import { useUXPContext } from './useUXPContext';
 *
 * const MyComponent = () => {
 *   const context = useUXPContext();
 *   return <div>{context.$L('hello')}</div>;
 * };
 *
 * ```
 *
 * @example
 * ```
 * import { UXPContext } from './Context';
 * import { useUXPContext } from './useUXPContext';
 *
 * const MyComponent = () => {
 *   const { $L, direction } = useUXPContext();
 *   return (
 *     <div style={{ direction: direction }}>
 *       <p>{ $L('welcome_message') }</p>
 *     </div>
 *   );
 * };
 * ```
 */
export const useUXPContext = () => {
    const context = useContext(UXPContext);
    if (!context) {
        throw new Error('useUXPContext must be used within a UXPContextProvider');
    }
    return context;
};
